export default __webpack_public_path__ + "static/media/header-logo.ef52a853.svg";